import React, { forwardRef, memo } from 'react';
import { Form } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import { withAnalyticsForm } from "../../hocs";
import { getModalData } from "./utils";
import { ModalController } from "./components/ModalContoller";
import { useFormLayout } from "./hooks/useFormLayout";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
var _FormLayout = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var form = _ref.form,
    _ref$modals = _ref.modals,
    modals = _ref$modals === void 0 ? {} : _ref$modals,
    landing = _ref.landing,
    setting = _ref.setting,
    onClick = _ref.onClick;
  var _useFormLayout = useFormLayout({
      landing: landing,
      setting: setting,
      onClick: onClick
    }),
    handleSubmit = _useFormLayout.handleSubmit,
    _useFormLayout$modal = _useFormLayout.modal,
    type = _useFormLayout$modal.type,
    data = _useFormLayout$modal.data;
  var _form$theme = form.theme,
    theme = _form$theme === void 0 ? 'main' : _form$theme;
  return /*#__PURE__*/React.createElement("div", {
    className: cn("form--".concat(theme)),
    ref: ref,
    "data-t-id": "components-FormLayout"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('form-layout')
  }, /*#__PURE__*/React.createElement(Form, {
    form: form,
    isSuccessSending: data.isSuccessSending,
    onSubmitForm: handleSubmit
  }), /*#__PURE__*/React.createElement(ModalController, {
    data: getModalData({
      type: type,
      data: data,
      modals: modals
    }),
    type: type
  })));
});
export var FormLayout = withAnalyticsForm( /*#__PURE__*/memo(_FormLayout));